<template>
  <Modal
    v-if="open"
    :model-value="true"
    title="Wipe import?"
    size="small"
    @update:model-value="emit('cancel')"
  >
    <p class="text-gray-700" data-cy="wipe-import-body">
      Records imported from {{ name }} will be deleted.
    </p>
    <template #footer>
      <div class="flex justify-end gap-2 p-4">
        <Button
          label="Cancel"
          type="Secondary"
          outline
          data-cy="wipe-import-cancel"
          @click="emit('cancel')"
        />
        <Button
          label="Wipe"
          type="Alert"
          data-cy="wipe-import-confirm"
          @click="emit('confirm')"
        />
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Button from "@/components/Seranova/Buttons/Button.vue";
import Modal from "@/components/Seranova/Modal/Modal.vue";

// `name` is display-ready: the hub decodes its HTML-escaped datatable text before passing it in.
defineProps<{ open: boolean; name: string }>();
const emit = defineEmits<{ confirm: []; cancel: [] }>();
</script>
